// extracted by mini-css-extract-plugin
export default {"admin":"Admin_admin__rZ9ze","header":"Admin_header__HczjY","logo":"Admin_logo__c3ngK","nav":"Admin_nav__wKiG9","active":"Admin_active__ehfox","content":"Admin_content__ooU-h"};